const LoadingNavigationBar = () => {
  return (
    <>
      <div
        style={{
          marginTop: "60%",
          paddingLeft: "10px",
          marginLeft: "30px",
          width: "70%",
        }}
      >
        <label>
          Waiting Interview Conduction
          <i
            className="pi pi-spin pi-spinner"
            style={{ marginLeft: "5px" }}
          ></i>
        </label>
      </div>
    </>
  )
}
export default LoadingNavigationBar
